// extracted by mini-css-extract-plugin
export default {"photo":"UserPhoto_photo__fYOS9","empty":"UserPhoto_empty__SHc3G","lg":"UserPhoto_lg__uhr98","md":"UserPhoto_md__kxAks","sm":"UserPhoto_sm__MyMeY","gray":"UserPhoto_gray__XKN8k"};